(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('simpleModalService', simpleModalService);

    simpleModalService.$inject = ['ModalService', '$q', '$templateCache'];

    function simpleModalService(ModalService, $q, $templateCache) {

        var modalTemplate = $templateCache.get('app/views/modals/general/YesNoBasicTemplate.html');
        var infoTemplate = $templateCache.get('app/views/modals/general/infoTemplate.html');
        var twoOptionsTemplate = $templateCache.get('app/views/modals/general/twoOptionsTemplate.html');


        var service = {
            yesNoModal: yesNoModal,
            infoModal: infoModal,
            showConfirmCloseModal: showConfirmCloseModal, 
            twoOptionsModal: twoOptionsModal
        };

        return service;

        function yesNoModal(title, msg, yesMsg, noMsg){

            var deferred = $q.defer();

            ModalService.showModal({
                template: modalTemplate,
                controller: function($scope, close){

                    $scope.title = title;
                    $scope.message = msg;
                    $scope.noText = noMsg ? noMsg : 'Cancelar';
                    $scope.yesText = yesMsg ? yesMsg : 'Aceptar';

                    $scope.close = function(result) {
                        close(result);
                    };
                }
            }).then(function(modal) {
                modal.close.then(function(result) {                        
                    deferred.resolve(result);
                });
            });

            return deferred.promise;
        }
        
        function infoModal(msg){
            var deferred = $q.defer();

            ModalService.showModal({
                template: infoTemplate,
                controller: function($scope, close){

                    $scope.message = msg;

                    $scope.close = function(result) {
                        close(result);
                    };
                }
            }).then(function(modal) {
                modal.close.then(function(result) {                        
                    deferred.resolve(result);
                });
            });

            return deferred.promise;
        }

		function showConfirmCloseModal(doSave, tab, callback) {
			ModalService.showModal({
				templateUrl: 'app/views/modals/general/confirmCloseWithoutSave.html',
				controller:
				function (close) {
					var modal = this;
					modal.tab = tab;

					modal.close = function (res) {
						close(res);
					};
					modal.saveAndClose = function (res) {
						doSave().then(function () {
							close(res);
						});
					};

				},
				controllerAs: 'modal'
			}).then(function (modal) {
				modal.close.then(function (result) {
					if (result) {
						tab.modified = false;
						callback(tab);
					}
				});
			});
        }
        
        function twoOptionsModal(title, msg, yesMsg, noMsg){

            var deferred = $q.defer();

            ModalService.showModal({
                template: twoOptionsTemplate,
                controller: function($scope, close){

                    $scope.title = title;
                    $scope.message = msg;
                    $scope.noText = noMsg ? noMsg : 'Cancelar';
                    $scope.yesText = yesMsg ? yesMsg : 'Aceptar';
                    $scope.option = "basico";
                    $scope.close = function(result) {
                        close(result);
                    };
                }
            }).then(function(modal) {
                modal.close.then(function(result) {                        
                    deferred.resolve(result);
                });
            });

            return deferred.promise;
        }
        
    }
})();